import { render, staticRenderFns } from "./FeatureCardHistory.vue?vue&type=template&id=222a3614&"
import script from "./FeatureCardHistory.vue?vue&type=script&lang=js&"
export * from "./FeatureCardHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports